import {ConfigCommit} from "@/store/module/enum/config-commit.enum";

export const config = {
    state: {},
    mutations: {
        [ConfigCommit.SET_CONFIG] (state: any, config: any) {
            state.config = config;
        },
        [ConfigCommit.SET_CURRENT_SPREADSHEET] (state: any, spreadsheetName: string) {
            state.config.spreadsheets[spreadsheetName].current = true;
        },
    },
    actions: {
        setCurrentSpreadsheet (context: any, spreadsheetName: string) {
            context.commit(ConfigCommit.SET_CURRENT_SPREADSHEET, spreadsheetName);
            context.dispatch('setPageTitle', spreadsheetName);
        },
        setPageTitle(context: any, formName: string) {
            if (!formName) {
                document.title = 'Commande - Les Pirates de la Bouffe'
            } else {
                const formLabel = formName.toString()
                    .trim()
                    .toLowerCase()
                    .replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));

                document.title = `Commande ${formLabel} - Les Pirates de la Bouffe`;
            }
        }
    },
    getters: {
        spreadsheetsName (state: any) {
          return Object.keys(state.config.spreadsheets);
        },
        currentSpreadsheet (state: any) {
            const spreadsheets = Object.keys(state.config.spreadsheets);

            const currentName: string|undefined = spreadsheets
                .find(spreadsheetName => state.config.spreadsheets[spreadsheetName].current);

            if (!currentName) {
                return;
            }

            return state.config.spreadsheets[currentName];
        },
        currentSpreadsheetName (state: any) {
            const spreadsheets = Object.keys(state.config.spreadsheets);

            const currentName: string|undefined = spreadsheets
                .find(spreadsheetName => state.config.spreadsheets[spreadsheetName].current);

            return currentName;
        },
        spreadsheetAccessibleRules: (state: any) => (spreadsheetName: string) => {
            const spreadsheet = state.config.spreadsheets[spreadsheetName];
            if (!spreadsheet) {
                return false;
            }

            return spreadsheet.accessible;
        },
        deliveryDate (state: any, getters: any) {
            return getters.currentSpreadsheet.deliveryDay;
        },
        orderSpreadsheetId (state: any, getters: any) {
            return getters.currentSpreadsheet.orderSpreadsheetId;
        },
        spreadsheetNextOrderDate: (state: any) => (spreadsheetName: string) => {
            const spreadsheet = state.config.spreadsheets[spreadsheetName];
            if (!spreadsheet) {
                return false;
            }

            return spreadsheet.nextOrderDay;
        }
    }
}
